<template>
	<div id='illustrate'>
		<Logo></Logo>
		<div id='experience-link'>
			证件照制作网页版体验链接：<a style="color: inherit;" href="https://www.91pitu.com/standardH5/">https://www.91pitu.com/standardH5/</a>
		</div>
		<div id="import-way-container">
			<div >
				<div class="import-way-title">如果您有WEB端开发能力，请选择</div>
				<div class="import-way-content">
					<div class="import-word">
						<div class="import-way-content-word">本产品基于Vue.js开发，故在非Vue项目中使用时，需先引入Vue.js。使用本产品时需传入相应APP_KEY，使用前需要设置好价格、支付参数等信息。以上参数均可在本后台查看或设置。</div>
					</div>
					<div class="import-way-content-button" @click="toInitialize">使用引用模块</div>
				</div>
			</div>
			
			<div id="import-way-right">
				<div class="import-way-title">如果您没有开发能力，请选择</div>
				<div class="import-way-content">
					<div class="import-word">
						<div class="import-way-content-word">您只需完成申请，使用前需要设置好价格、支付参数等信息。以上参数均可在本后台查看或设置。完成设置后，会为您提供一个独立页面进行使用。</div>
						<div class="import-way-tips">
							<div id='alert'>注意：由于技术原因，独立页面的域名由我司提供，无法指定。</div>
							<div id='normal'>有问题可以联系商务经理：18014955375</div>
						</div>
					</div>
					<div class="import-way-content-button" @click="toInitialize">使用网页版</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import Logo from '../components/Logo.vue'
export default {
	data() {
		return {
			
		}
	},
	components:{
		Logo
	},
	methods:{
		toInitialize:function(){
			this.$router.push("/initialize")
		}
	}
}
</script>

<style scoped="scoped">
	#illustrate{
		background-image: url(../assets/top@2x.png);
		background-position: 0 0;
		background-size: 100% 50%;
		background-repeat: no-repeat;
		height: 100vh;
	}
	#experience-link{
		font-size: 16px;
		color: #FFFFFF;
		padding-top: 40px;
		padding-left: 64px;
	}
	#import-way-container{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		margin-top: 115px;
	}
	#import-way-right{
		margin-left: 140px;
	}
	.import-way-title{
		font-size: 22px;
		font-weight: bold;
		color: #FFFFFF;
	}
	.import-way-content{
		width: 410px;
		height: 334px;
		background: #FFFFFF;
		box-shadow: 0px 4px 16px 0px rgba(234, 238, 246, 0.3);
		border-radius: 10px;
		border: 1px solid #C8D3E5;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-around;
		flex-direction: column;
		padding: 0 55px;
		margin-top: 30px;
	}
	.import-way-content-word{
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #4C4C4C;
	}
	.import-way-tips>div{
		font-size: 14px;
		position: relative;
	}
	#normal{
		color: #4C4C4C;
	}
	#normal::before{
		content: " ";
		background-image: url(../assets/icon_call@2x.png);
		background-size: 14px 14px;
		background-position: 0 0;
		position: absolute;
		left: -20px;
		width: 14px;
		height: 14px;
	}
	#alert{
		color: #FF6161;
	}
	#alert::before{
		content: " ";
		background-image: url(../assets/icon_notice@2x.png);
		background-size: 14px 14px;
		background-position: 0 0;
		position: absolute;
		left: -20px;
		width: 14px;
		height: 14px;
	}
	.import-way-content-button{
		width: 242px;
		height: 56px;
		background: #287AFF;
		border-radius: 6px;
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
		line-height: 56px;
		cursor: pointer;
	}
	.import-word{
		height: 104px;
	}
</style>
